import { Capacitor } from "@capacitor/core";

export function isNativePlatform(): boolean {
  return Capacitor.isNativePlatform();
}

export function isNativeIOS(): boolean {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === "ios";
}

/**
 * Detects iOS broadly: native (Capacitor) **and** Safari iPad/iPhone direct.
 * Used to enable mobile-tier perf budgets (lower Pixi FPS, no reverb, single
 * Salamander velocity layer) regardless of how the app was opened.
 *
 * Catches modern iPads which advertise themselves as `MacIntel` but expose
 * touch points (`navigator.platform === "MacIntel" && maxTouchPoints > 1`).
 */
export function isIOS(): boolean {
  if (isNativeIOS()) {
    return true;
  }

  if (typeof navigator === "undefined") {
    return false;
  }

  const ua = navigator.userAgent ?? "";

  if (/iPad|iPhone|iPod/.test(ua)) {
    return true;
  }

  return navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
}

/**
 * Un téléphone : un doigt pour pointeur, et un écran dont le petit côté fait
 * moins de 600 px CSS.
 *
 * L'écran et non la fenêtre : un téléphone couché reste un téléphone, et une
 * fenêtre étroite sur un ordinateur n'en est pas un. Les tablettes — l'iPad
 * compris, qui se dit `MacIntel` — dépassent les 600 px et n'en sont pas non
 * plus.
 *
 * Pour les budgets de rendu, pas pour la mise en page : celle-ci suit la
 * fenêtre (`use-short-viewport.ts`).
 */
export function isPhone(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return false;
  }

  const shortSide = Math.min(window.screen.width, window.screen.height);

  return window.matchMedia("(pointer: coarse)").matches && shortSide < 600;
}
